import * as React from "react";
import { BaseProps } from "global";

import classNames from "shared/utils/classNames";

export interface ISendButtonProps extends BaseProps {
  isLoading?: boolean;
  type?: "done" | "default" | "disabled";
}

export function SendButton(props: ISendButtonProps) {
  const { isLoading, type = "default" } = props;
  if (type === "done") {
    return BUTTON_DONE;
  }
  if (isLoading) {
    return LOADER;
  }
  return (
    <button
      type="submit"
      disabled={type === "disabled"}
      className={classNames(
        "flex h-6 w-6 items-center justify-center rounded-full border-transparent bg-[var(--chatBotOrDarkColor)]",
        type === "disabled" ? "opacity-20" : "",
      )}
    >
      {isLoading ? LOADER : SVG_SEND}
    </button>
  );
}
// TODO create a image component and add these there. also add option to prefetch it.
const SVG_SEND = (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5865_22326)">
      <path
        d="M10.4727 5.3427L2.57428 0.922388C2.44267 0.845643 2.29114 0.809992 2.13912 0.820015C1.9871 0.830038 1.84155 0.885277 1.72116 0.978638C1.5982 1.07564 1.50894 1.20892 1.46603 1.35953C1.42311 1.51015 1.42874 1.67046 1.4821 1.8177L2.79928 5.49739C2.81261 5.53408 2.83679 5.56584 2.86861 5.58844C2.90043 5.61106 2.93838 5.62344 2.97741 5.62395H6.36178C6.45909 5.62241 6.55336 5.65784 6.62557 5.72308C6.69778 5.78833 6.74255 5.87854 6.75085 5.97551C6.75405 6.02669 6.74672 6.07799 6.72932 6.12622C6.71191 6.17446 6.6848 6.21862 6.64966 6.25597C6.6145 6.29331 6.57208 6.32305 6.52498 6.34334C6.47788 6.36364 6.42712 6.37405 6.37585 6.37395H2.97741C2.93838 6.37446 2.90043 6.38685 2.86861 6.40945C2.83679 6.43207 2.81261 6.46382 2.79928 6.50051L1.4821 10.1802C1.44257 10.2936 1.43066 10.4147 1.44736 10.5336C1.46405 10.6525 1.50886 10.7657 1.57808 10.8638C1.64729 10.9618 1.7389 11.042 1.84531 11.0976C1.95172 11.1531 2.06986 11.1825 2.18991 11.1834C2.31766 11.1828 2.44327 11.1505 2.55553 11.0896L10.4727 6.6552C10.5887 6.58933 10.6852 6.4939 10.7523 6.37862C10.8194 6.26334 10.8547 6.13234 10.8547 5.99895C10.8547 5.86556 10.8194 5.73456 10.7523 5.61928C10.6852 5.504 10.5887 5.40857 10.4727 5.3427Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5865_22326">
        <rect
          width="10.5"
          height="10.5"
          fill="white"
          transform="translate(0.75 0.75)"
        />
      </clipPath>
    </defs>
  </svg>
);
const LOADER = (
  <div role="status" className="flex items-center justify-center">
    <svg
      aria-hidden="true"
      className="inline h-5 w-5 animate-spin fill-[var(--chatBotOrDarkColor)] stroke-2 text-gray-200"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
    <span className="sr-only">Loading...</span>
  </div>
);
const BUTTON_DONE = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
      stroke="#38A911"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 10L11 15L8 12"
      stroke="#38A911"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
